export default __webpack_public_path__ + "static/media/s4_xit-summer.31a98f7f.png";